import { LOGIN_SUCCESS } from "../constants/types";
import { refreshApiClient } from "../services/api";

const completeLogin = (dispatch, history, payload) => {
  localStorage.setItem("user_token", payload.token);
  localStorage.setItem("user_role", payload.role);
  if (payload.email) localStorage.setItem("user_email", payload.email);
  if (payload.username) localStorage.setItem("username", payload.username);
  if (payload.partnerId) localStorage.setItem("partner_id", payload.partnerId);
  refreshApiClient();
  dispatch({ type: LOGIN_SUCCESS, data: payload });

  if (payload.role === "admin") {
    history("/admin/dashboard", { replace: true, state: { token: payload.token } });
  } else if (
    payload.role === "content_feeder" ||
    payload.role === "content_validator"
  ) {
    history("/cm/dashboard", { replace: true });
  } else if (payload.role === "partner") {
    history("/partner/dashboard", { replace: true });
  }
};

export default completeLogin;
